/* eslint-disable import/prefer-default-export */
import { SetStateAction, useCallback, useRef, useState } from 'react'
import { useEffectUpdate } from './use.effect.update.hook'

type Callback<T> = (value?: T) => void
type DispatchWithCallback<T> = (value: T, callback?: Callback<T>) => void

export const useStateCallback = <T extends {}>(
  initialState: T | (() => T)
): [T, DispatchWithCallback<SetStateAction<T>>] => {
  const [state, _setState] = useState(initialState)

  const callbackRef = useRef<Callback<T>>()

  const setState = useCallback(
    (setStateAction: SetStateAction<T>, callback?: Callback<T>): void => {
      callbackRef.current = callback
      _setState(setStateAction)
    },
    []
  )

  useEffectUpdate(() => {
    callbackRef.current?.(state)
  }, [state])

  return [state, setState]
}
